import { getMix } from "../utils/fetch.js";
import { ApiData } from "../schema/apiData.js";
import { ChildCheckStats, Item, Items, ParentItem } from "../schema/item.js";
import { calcCheckStats } from "./tsx/cell/check.jsx";

export const fetchMixData = async (): Promise<ParentItem[]> => {
  const rawData = (await getMix()) as any[];
  const datum = rawData;
  return parseData(datum);
};

const parseData = (datum): ParentItem[] => {
  const result: ParentItem[] = [];
  datum.forEach((data) => {
    const item = structuredClone(data);
    // console.log(data);
    try {
      const parent: ParentItem = {
        id: `${item.id}-mix`,
        name: JSON.parse(item.name).name,
        brandObject: JSON.parse(item.brand),
        childCheckState: { owned: 0, total: 0, comp: false },
        sec: "",
        star: "",
        children: [],
        mixItems: JSON.parse(item.items),
        scope: item.scope,
        element: document.createElement("tr"),
        rowState: {
          open: false,
          selected: false,
        },
      };
      result.push(parent);
    } catch (e) {
      // alert(e);
    }
  });
  return result;
};
